var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"title":_vm.title,"visible":true,"footer":null},on:{"cancel":_vm.handleCancel}},[_c('dynamic-form',{attrs:{"schema":_vm.schema,"api":_vm.api,"editMode":false,"renderParams":_vm.renderParams},on:{"cancel":_vm.handleCancel,"sucess":_vm.handleSuccess}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }